import { loaderTemplate } from './loader.template';
import { loaderStyles } from './loader.styles';
import { attr, FASTElement } from '@microsoft/fast-element';
import { NatGenDesignSystem } from '../../natgen-design-system';

export type LoaderAppearance = 'dots' | 'waves' | 'spinner';

const animationPieces = {
    'dots': 3,
    'waves': 15,
    'spinner':8
};

/**
 * @element natgen-loader
 */
export class NatGenLoader extends FASTElement {
    @attr
    appearance: LoaderAppearance = 'dots';

    parts() : number[] {
        return Array.from({ length: animationPieces[this.appearance] }, () => animationPieces[this.appearance]);
    }
}

export const natGenLoaderDefinition = NatGenLoader.compose({
    name: `${NatGenDesignSystem.prefix}-loader`,
    template: loaderTemplate(),
    styles: loaderStyles
});
